// Studyo Today Backend
// Package studyo.today.planners.v1.resources
// Resource definitions
// Copyright (c) 2015-2023 Intuitic Inc.

// @generated by protoc-gen-es v2.2.5 with parameter "import_extension=js"
// @generated from file studyo/today/planners/v1/resources/planner_relationship.proto (package studyo.today.planners.v1.resources, syntax proto3)
/* eslint-disable */

import { fileDesc, messageDesc } from "@bufbuild/protobuf/codegenv1";
import { file_studyo_today_planners_v1_resources_planner_relationship_kind } from "./planner_relationship_kind_pb.js";

/**
 * Describes the file studyo/today/planners/v1/resources/planner_relationship.proto.
 */
export const file_studyo_today_planners_v1_resources_planner_relationship = /*@__PURE__*/
  fileDesc("Cj1zdHVkeW8vdG9kYXkvcGxhbm5lcnMvdjEvcmVzb3VyY2VzL3BsYW5uZXJfcmVsYXRpb25zaGlwLnByb3RvEiJzdHVkeW8udG9kYXkucGxhbm5lcnMudjEucmVzb3VyY2VzInEKE1BsYW5uZXJSZWxhdGlvbnNoaXASDwoHdXNlcl9pZBgBIAEoCRJJCgRraW5kGAIgASgOMjsuc3R1ZHlvLnRvZGF5LnBsYW5uZXJzLnYxLnJlc291cmNlcy5QbGFubmVyUmVsYXRpb25zaGlwS2luZEIqqgInU3R1ZHlvLlRvZGF5LlBsYW5uZXJzLkdycGMuVjEuUmVzb3VyY2VzYgZwcm90bzM", [file_studyo_today_planners_v1_resources_planner_relationship_kind]);

/**
 * Describes the message studyo.today.planners.v1.resources.PlannerRelationship.
 * Use `create(PlannerRelationshipSchema)` to create a new message.
 */
export const PlannerRelationshipSchema = /*@__PURE__*/
  messageDesc(file_studyo_today_planners_v1_resources_planner_relationship, 0);

